import template from './patientConnection.completed.html';

export const CompletedComponent = {
    name: 'mmsPatientConnectionCompleted',
    component: {
        template,
        bindings: {
            connectionStatus: '<',
            patient: '<',
            careTeam: '<',
            expired: '<',
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/patientConnection/completed/patientConnection.completed.component.js